/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BasicShopStatistics,
  CampaignMoneyGraphData,
  CampaignNumberGraphData,
  CountryPaymentAndShippingStatistics,
  CouponPerformance,
  CouponStats,
  DailyCountryData,
  DailyOverviewData,
  DailyPaymentData,
  DailyShippingData,
  DateRangeInput,
  DateRangeOrdersGranular,
  DayInput,
  DiscountPerformance,
  ErpFilter,
  ErrorResponse,
  ShopPerformance,
  ShopPerformancePno,
  StatisticsBySource,
  TopChannelsData,
  TopProductData,
} from '../models/index';
import {
    BasicShopStatisticsFromJSON,
    BasicShopStatisticsToJSON,
    CampaignMoneyGraphDataFromJSON,
    CampaignMoneyGraphDataToJSON,
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataToJSON,
    CountryPaymentAndShippingStatisticsFromJSON,
    CountryPaymentAndShippingStatisticsToJSON,
    CouponPerformanceFromJSON,
    CouponPerformanceToJSON,
    CouponStatsFromJSON,
    CouponStatsToJSON,
    DailyCountryDataFromJSON,
    DailyCountryDataToJSON,
    DailyOverviewDataFromJSON,
    DailyOverviewDataToJSON,
    DailyPaymentDataFromJSON,
    DailyPaymentDataToJSON,
    DailyShippingDataFromJSON,
    DailyShippingDataToJSON,
    DateRangeInputFromJSON,
    DateRangeInputToJSON,
    DateRangeOrdersGranularFromJSON,
    DateRangeOrdersGranularToJSON,
    DayInputFromJSON,
    DayInputToJSON,
    DiscountPerformanceFromJSON,
    DiscountPerformanceToJSON,
    ErpFilterFromJSON,
    ErpFilterToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ShopPerformanceFromJSON,
    ShopPerformanceToJSON,
    ShopPerformancePnoFromJSON,
    ShopPerformancePnoToJSON,
    StatisticsBySourceFromJSON,
    StatisticsBySourceToJSON,
    TopChannelsDataFromJSON,
    TopChannelsDataToJSON,
    TopProductDataFromJSON,
    TopProductDataToJSON,
} from '../models/index';

export interface ChannelPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ClicksInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface CouponPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface CpcInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface DailyCountryPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyCouponPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyOrderPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyPaymentPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyProductPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyShippingPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyTopChannelPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DiscountPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrderOverviewRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrdersInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface PnoInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ProductPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopBasicStatisticsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopChannelsStatisticsBySourceRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface ShopCountryPaymentAndShippingStatisticsRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface ShopPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOChannelsOnlyRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOTotalRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOTotalWithoutOfflineRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopTurnoverByDomainStatisticsRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

/**
 * 
 */
export class ErpCalculationApi extends runtime.BaseAPI {

    /**
     * Returns top channels data.
     */
    async channelPerformanceRaw(requestParameters: ChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopChannelsData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling channelPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/channel-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopChannelsDataFromJSON(jsonValue));
    }

    /**
     * Returns top channels data.
     */
    async channelPerformance(requestParameters: ChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopChannelsData> {
        const response = await this.channelPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async clicksInTimeRaw(requestParameters: ClicksInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling clicksInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/clicks-in-time`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async clicksInTime(requestParameters: ClicksInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.clicksInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data.
     */
    async couponPerformanceRaw(requestParameters: CouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponPerformance>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling couponPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/coupon-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns data.
     */
    async couponPerformance(requestParameters: CouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponPerformance> {
        const response = await this.couponPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async cpcInTimeRaw(requestParameters: CpcInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignMoneyGraphData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling cpcInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/cpc-in-time`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignMoneyGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async cpcInTime(requestParameters: CpcInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignMoneyGraphData> {
        const response = await this.cpcInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async dailyCountryPerformanceRaw(requestParameters: DailyCountryPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyCountryData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyCountryPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-country-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyCountryDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dailyCountryPerformance(requestParameters: DailyCountryPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyCountryData> {
        const response = await this.dailyCountryPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async dailyCouponPerformanceRaw(requestParameters: DailyCouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponStats>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyCouponPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-coupons-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponStatsFromJSON));
    }

    /**
     * Returns data file uri.
     */
    async dailyCouponPerformance(requestParameters: DailyCouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponStats>> {
        const response = await this.dailyCouponPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async dailyOrderPerformanceRaw(requestParameters: DailyOrderPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyOverviewData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyOrderPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-order-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyOverviewDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dailyOrderPerformance(requestParameters: DailyOrderPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyOverviewData> {
        const response = await this.dailyOrderPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns payment data.
     */
    async dailyPaymentPerformanceRaw(requestParameters: DailyPaymentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyPaymentData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyPaymentPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-payment-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyPaymentDataFromJSON(jsonValue));
    }

    /**
     * Returns payment data.
     */
    async dailyPaymentPerformance(requestParameters: DailyPaymentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyPaymentData> {
        const response = await this.dailyPaymentPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Product performance data.
     */
    async dailyProductPerformanceRaw(requestParameters: DailyProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopProductData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyProductPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-product-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopProductDataFromJSON(jsonValue));
    }

    /**
     * Product performance data.
     */
    async dailyProductPerformance(requestParameters: DailyProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopProductData> {
        const response = await this.dailyProductPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns payment data.
     */
    async dailyShippingPerformanceRaw(requestParameters: DailyShippingPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyShippingData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyShippingPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-shipping-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyShippingDataFromJSON(jsonValue));
    }

    /**
     * Returns payment data.
     */
    async dailyShippingPerformance(requestParameters: DailyShippingPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyShippingData> {
        const response = await this.dailyShippingPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns top channel data.
     */
    async dailyTopChannelPerformanceRaw(requestParameters: DailyTopChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopChannelsData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyTopChannelPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/daily-top-channels-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopChannelsDataFromJSON(jsonValue));
    }

    /**
     * Returns top channel data.
     */
    async dailyTopChannelPerformance(requestParameters: DailyTopChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopChannelsData> {
        const response = await this.dailyTopChannelPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data.
     */
    async discountPerformanceRaw(requestParameters: DiscountPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscountPerformance>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discountPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/discount-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns data.
     */
    async discountPerformance(requestParameters: DiscountPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscountPerformance> {
        const response = await this.discountPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async orderOverviewRaw(requestParameters: OrderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DateRangeOrdersGranular>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling orderOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/order-overview`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DateRangeOrdersGranularFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async orderOverview(requestParameters: OrderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DateRangeOrdersGranular> {
        const response = await this.orderOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async ordersInTimeRaw(requestParameters: OrdersInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling ordersInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/orders-in-time`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async ordersInTime(requestParameters: OrdersInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.ordersInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async pnoInTimeRaw(requestParameters: PnoInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling pnoInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/pno-in-time`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async pnoInTime(requestParameters: PnoInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.pnoInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Product performance data.
     */
    async productPerformanceRaw(requestParameters: ProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopProductData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling productPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/product-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopProductDataFromJSON(jsonValue));
    }

    /**
     * Product performance data.
     */
    async productPerformance(requestParameters: ProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopProductData> {
        const response = await this.productPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns shop performance data.
     */
    async shopBasicStatisticsRaw(requestParameters: ShopBasicStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasicShopStatistics>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopBasicStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-statistics/basic`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasicShopStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopBasicStatistics(requestParameters: ShopBasicStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BasicShopStatistics> {
        const response = await this.shopBasicStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns shop performance data.
     */
    async shopChannelsStatisticsBySourceRaw(requestParameters: ShopChannelsStatisticsBySourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsBySource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopChannelsStatisticsBySource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-statistics/statistics-by-source`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsBySourceFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopChannelsStatisticsBySource(requestParameters: ShopChannelsStatisticsBySourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsBySource> {
        const response = await this.shopChannelsStatisticsBySourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns shop performance data.
     */
    async shopCountryPaymentAndShippingStatisticsRaw(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountryPaymentAndShippingStatistics>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopCountryPaymentAndShippingStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-statistics/country-payment-shipping`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryPaymentAndShippingStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopCountryPaymentAndShippingStatistics(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountryPaymentAndShippingStatistics> {
        const response = await this.shopCountryPaymentAndShippingStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns shop performance data.
     */
    async shopPerformanceRaw(requestParameters: ShopPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformance>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-performance`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopPerformance(requestParameters: ShopPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformance> {
        const response = await this.shopPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOChannelsOnlyRaw(requestParameters: ShopPerformancePNOChannelsOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOChannelsOnly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-performance-pno/channels-only`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOChannelsOnly(requestParameters: ShopPerformancePNOChannelsOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOChannelsOnlyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalRaw(requestParameters: ShopPerformancePNOTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOTotal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-performance-pno/total`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotal(requestParameters: ShopPerformancePNOTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOTotalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalWithoutOfflineRaw(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOTotalWithoutOffline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-performance-pno/total-without-offline`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalWithoutOffline(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOTotalWithoutOfflineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns shop performance data.
     */
    async shopTurnoverByDomainStatisticsRaw(requestParameters: ShopTurnoverByDomainStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopTurnoverByDomainStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/erp/shop-statistics/turnover-by-domain`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns shop performance data.
     */
    async shopTurnoverByDomainStatistics(requestParameters: ShopTurnoverByDomainStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.shopTurnoverByDomainStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
